module.exports = __webpack_public_path__ + "img/J1L-Logo1.c84f1d44.svg";